import gql from 'graphql-tag';

import { executeGqlQuery, type GqlQueryOptions } from 'src/graphql/client';
import { FRAGMENT_IMAGE_STYLE } from 'src/graphql/imageStyle';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendQueryWorkspacesArgs, BackendWorkspaceConnection } from 'src/types/backend';

import { FRAGMENT_VISUAL_LANGUAGE } from './schema';

const QUERY = gql`
  query WorkspaceVisualLanguages($customerId: ID!, $id: ID) {
    workspaces(customerId: $customerId, id: $id) {
      edges {
        node {
          id
          visualLanguages {
            ...VisualLanguage

            imageStyles {
              ...ImageStyle
            }
          }
          defaultVisualLanguage {
            id
          }
        }
      }
    }
  }
  ${FRAGMENT_VISUAL_LANGUAGE}
  ${FRAGMENT_IMAGE_STYLE}
`;

type Variables = Pick<BackendQueryWorkspacesArgs, 'customerId'> & {
  workspaceId?: BackendQueryWorkspacesArgs['id'];
};

export const queryWorkspaceVisualLanguagesWithAssets = async (
  { customerId, workspaceId }: Variables,
  options?: Pick<GqlQueryOptions, 'abortSignal'>
) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: { customerId, id: workspaceId },
    options: {
      abortSignal: options?.abortSignal,
    },
  });

  const data = getSingleProp<BackendWorkspaceConnection>(result.data);
  const workspace = data?.edges?.[0]?.node;
  return {
    visualLanguages: workspace?.visualLanguages ?? [],
    defaultVisualLanguageId: workspace?.defaultVisualLanguage?.id ?? null,
  };
};
